import ApiClient from 'api-client/ApiClient'
import ActionsSet from 'core/actions/ActionsSet'
import ListAction from 'core/actions/ListAction'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'
import Bugsnag from 'utils/bugsnag'

const { opencloud } = ApiClient.getInstance()

const regionsMetadataActions = ActionsSet.make<DataKeys.RegionsMetadata>({
  uniqueIdentifier: 'name',
  entityName: entityNamesByKey.RegionsMetadata,
  cacheKey: DataKeys.RegionsMetadata,
})

export const listRegionsMetadata = regionsMetadataActions.add(
  new ListAction<DataKeys.RegionsMetadata>(async () => {
    Bugsnag.leaveBreadcrumb('Attempting to load Regions Metadata')
    return opencloud.getRegionsMetadata()
  }),
)
